"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'taskListByAddress',
      apiModule: 'kpiSet',
      searchQuery: {
        provinceCode: '',
        cityCode: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  computed: {
    domData: function domData() {
      return {
        provinceCode: {
          label: this.$t('common.province'),
          valueKey: 'provinceCode',
          contactQueryKey: 'cityCode',
          inputType: 'province'
        },
        cityCode: {
          label: this.$t('common.city'),
          valueKey: 'cityCode',
          inputType: 'city'
        },
        timeRange: {
          label: this.$t('common.date'),
          valueKey: 'timeRange',
          inputType: 'daterange',
          keyList: ['startTime', 'endTime']
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.tasklistbyaddress'),
          apiUrl: '/protected/pc/report/regionNew/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        provinceName: {
          label: this.$t('common.province')
        },
        cityName: {
          label: this.$t('common.city')
        },
        newStoreCount: {
          label: this.$t('sfe.planAndTaskReport.newVisitNum'),
          isCommasNumber: true
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/pc/report/regionNew/list'
      };
    }
  }
};